import React from "react";
import AutocompleteInput from "../tailwind/autocomplete-input";

const TagInput = ({
  value,
  onChange,
  onSelect,
  options = [],
  selected = null,
}) => {
  return (
    <AutocompleteInput
      value={value}
      onChange={(e) => {
        // Safely handle different types of onChange events
        if (e && e.target && e.target.value !== undefined) {
          onChange(e.target.value);
        } else if (typeof e === "string") {
          onChange(e);
        } else if (e && e.label) {
          onChange(e.label);
        } else {
          onChange("");
        }
      }}
      options={options}
      selected={selected}
      onSelect={onSelect}
    />
  );
};

export default TagInput;
